import { useSuspenseQuery } from "@tanstack/react-query"
import { useParams } from "@tanstack/react-router"
import type { Permission } from "@vienna/contracts"
import { meQuery, workspaceQuery } from "./queries"

/** Signed-in account. Routes under /w/$workspace guarantee the query is primed. */
export function useMe() {
  return useSuspenseQuery(meQuery).data
}

/** Current workspace, role and effective permissions for the signed-in member. */
export function useWorkspaceContext() {
  const { workspace } = useParams({ from: "/w/$workspace" })
  return useSuspenseQuery(workspaceQuery(workspace)).data
}

export function useCan() {
  const { permissions } = useWorkspaceContext()
  return (permission: Permission) => permissions.includes(permission)
}
